<form>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="400px" [formGroup]="editForm">
      <mat-card appearance="outlined" class="sign-up-card">
        <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
          <h3 mat-dialog-title>{{'アカウント作成' | translate}}</h3>
          <mat-form-field>
            <mat-label>{{'メールアドレス' | translate}}</mat-label>
            <input matInput type="admin_id" placeholder="{{'メールアドレス' | translate}}" id="admin_id"
              formControlName="admin_id" autocomplete="off" required>
            <mat-error *ngIf="adminIdControl.invalid">{{ getErrorMessageToAdminId() }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'パスワード' | translate}}</mat-label>
            <input matInput type="password" placeholder="{{'パスワード' | translate}}" id="password"
              formControlName="password" autocomplete="off" required>
            <mat-error *ngIf="passwordControl.invalid">{{ getErrorMessageToPassword() }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'確認パスワード' | translate}}</mat-label>
            <input matInput type="password" placeholder="{{'確認パスワード' | translate}}" id="comfirm_password"
              formControlName="comfirm_password" autocomplete="off" required>
            <mat-error *ngIf="comfirmPasswordControl.invalid">{{ getErrorMessageToComfirmPassword() }}</mat-error>
          </mat-form-field>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <button mat-button color="accent" routerLink="/sign-in" cdkFocusInitial><mat-icon
                class="mat-icon-event-btn">reply</mat-icon>{{'ログインへ' | translate}}</button>
            <button mat-button color="primary" (click)="signup()" [disabled]="editForm.invalid"><mat-icon
                class="mat-icon-event-btn">account_circle</mat-icon>{{'アカウント作成' | translate}}</button>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="center center">
            <span style="color: #FF0000; font-size:11px;">
              {{'＊＊＊＊＊　　注意点　　＊＊＊＊＊' | translate}}
            </span>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <span style="color: #FF0000; font-size:11px;">
              {{'sign-up.CAUTION_CONTENT' | translate}}
            </span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</form>